import {driver} from 'driver.js'
import 'driver.js/dist/driver.css'
import {prepareRouteGuideAnchors} from './anchors'

const {collectScenarioSteps} = require('./runtimeCore.cjs')

let activeDriver = null

function restoreFocus(element) {
  if (!element || !element.isConnected || typeof element.focus !== 'function') return
  try {
    element.focus({preventScroll: true})
  } catch (error) {
    element.focus()
  }
}

function escapeHtml(value) {
  return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
}

function renderDescription(value) {
  return `<p>${escapeHtml(value).replace(/\n/g, '<br>')}</p>`
}

/**
 * 启动一个页面专属任务场景。
 * 运行器不拼接业务文案；目标缺失、被权限隐藏或仍未打开时，只跳过该步骤。
 */
export function startGuide(guide, options = {}) {
  if (!guide || typeof document === 'undefined') return false
  destroyActiveGuide()
  prepareRouteGuideAnchors(guide.routeName, document)
  const previousFocus = document.activeElement
  const steps = collectScenarioSteps(guide, document).map((step) => ({
    ...step,
    popover: {
      ...step.popover,
      title: escapeHtml(step.popover.title),
      description: renderDescription(step.popover.description),
    },
  }))
  if (!steps.length) return false

  let outcome = ''
  const onStatus = typeof options.onStatus === 'function' ? options.onStatus : () => {}
  const instance = driver({
    animate: true,
    allowClose: true,
    allowKeyboardControl: true,
    disableActiveInteraction: true,
    overlayClickBehavior: 'close',
    overlayColor: '#10243f',
    overlayOpacity: 0.58,
    popoverClass: 'qcyy-guide-popover',
    nextBtnText: '继续',
    prevBtnText: '返回',
    doneBtnText: '明白了',
    progressText: '{{current}} / {{total}}',
    showProgress: steps.length > 1,
    skipMissingElement: true,
    smoothScroll: true,
    stagePadding: 8,
    stageRadius: 10,
    steps,
    onDoneClick: () => {
      outcome = 'COMPLETED'
      onStatus(outcome)
      instance.destroy()
    },
    onCloseClick: () => {
      outcome = 'DISMISSED'
      onStatus(outcome)
      instance.destroy()
    },
    onDestroyed: () => {
      if (!outcome) onStatus('DISMISSED')
      if (activeDriver === instance) activeDriver = null
      restoreFocus(previousFocus)
    },
  })
  activeDriver = instance
  onStatus('VIEWED')
  instance.drive()
  return true
}

/** 路由切换、退出登录或布局销毁时清理当前弹层并恢复原焦点。 */
export function destroyActiveGuide() {
  if (activeDriver && activeDriver.isActive()) activeDriver.destroy()
  activeDriver = null
}
